import './themes.scss'
import AppTheme from './themes'
import Vue from 'vue'

// 测试使用，设置主题为blue
AppTheme.setTheme('blue')

// vue写入AppTheme
Vue.prototype.$appTheme = AppTheme
